export default function () {
    $(() => {
        $('.header-promo__slider').slick({
            "slidesToShow": 1,
            "autoplay": true,
            "dots": false,
            "arrows": true
        });

        $('.header-promo__toggle-btn').on('click', (e) => {
            e.preventDefault();
            $('.header-promo').toggleClass('hidden');
        });

        // Hide header promo on mobile when scrolling down
        let lastScrollTop = 0;
        const isMobile = () => window.innerWidth <= 768;

        $(window).on('scroll', () => {
            if (!isMobile()) return;

            const scrollTop = $(window).scrollTop();
            
            if (scrollTop > lastScrollTop && scrollTop > 100) {
                // Scrolling down
                $('.header-promo').addClass('hidden from-scroll');
            } else if (scrollTop < lastScrollTop && $('.header-promo').hasClass('from-scroll')) {
                // Scrolling up and was hidden by scroll
                $('.header-promo').removeClass('hidden from-scroll');
            }
            
            lastScrollTop = scrollTop;
        });
    });
}
